import { register } from '../component.js';
import 'react';

var _socialIcons_bandsintown = register("bandsintown", {"color":"#1B8793","path":"M0,0v64h64V0H0z M32.6,24.7h5.6v7.8h-5.6V24.7z M25.8,24.7h5.6v7.8h-5.6V24.7z M44.9,46H19.1V18h5.6v22.4h14.6 v-1.1H25.8v-5.6h19V46z M44.9,32.6h-5.6V18h5.6V32.6z"});

export { _socialIcons_bandsintown as default };
